/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs';
import {
    PartNumberChangeReportResultContract
} from './contracts/part-number-change-export-excel/contracts/part-number-change-report-result.contract';
import {
    PartNumberChangeExportExcelQueryModel
} from './contracts/part-number-change-export-excel/models/part-number-change-export-excel-query.model';

@Injectable({
    providedIn: 'root'
})
export class PartNumberChangesExportExcelApi {

    private partNumberChangesBaseUrl = `${environment.partNumberChangesBaseUrl}/api/partNumberChange`;
    private partNumberChangesReportUrl = `${this.partNumberChangesBaseUrl}/report/search`;
    private partNumberReportTodoUrl = `${this.partNumberChangesReportUrl}/toDo`;
    private partNumberReportMyListUrl = `${this.partNumberChangesReportUrl}/myList`;

    constructor(private http: HttpClient) {
    }

    getPartNumberChangesReport(queryModel: PartNumberChangeExportExcelQueryModel): Observable<PartNumberChangeReportResultContract> {
        return this.http.post<PartNumberChangeReportResultContract>(this.partNumberChangesReportUrl, queryModel);
    }

    getPartNumberChangesMyListReport(queryModel: {}):
            Observable<PartNumberChangeReportResultContract> {
        return this.http.post<PartNumberChangeReportResultContract>(this.partNumberReportMyListUrl, queryModel);
    }

    getPartNumberChangesTodoReport(queryModel: PartNumberChangeExportExcelQueryModel):
            Observable<PartNumberChangeReportResultContract> {
        return this.http.post<PartNumberChangeReportResultContract>(this.partNumberReportTodoUrl, queryModel);
    }
}
